// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"style_paragraph__aZFWU"};